// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__3lSM6","img":"NavBar_img__3B8-p"};